import router from '@/router';
import { local } from '@/utils/storage';
import axios from 'axios';
import { Message } from 'element-ui';
import store from '../store/index';
axios.defaults.timeout = 1000000;
axios.interceptors.request.use(
  config => {
    if (local.get('Token')) {
      // console.log(local.get('Token'), '78978979token');
      config.headers['Authorization'] = 'Bearer ' + local.get('Token');
      // config.headers["currentOrganizationId"] = local.get("currentOrganizationId")
      store.commit('showLoading');
    } else {
      console.log(local.get('Token'), '8989898989');
    }
    // Authorization Bearer
    return config;
  },
  error => {
    store.commit('hideLoading');
    console.log(local.get('Token'), '*45454545');
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  response => {
    store.commit('hideLoading');
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 302:
          store.commit('hideLoading');
          local.clear();
          router.push('/');
          break;
        case 401:
          store.commit('hideLoading');
          Message.error(error.response.data.Message);
          local.clear();
          router.push('/');
          break;
        case 403:
          store.commit('hideLoading');
          Message.error('403错误');
          console.log('403错误', local.get('Token'));
          break;
        case 500 || 502 || 503 || 504:
          store.commit('hideLoading');
          Message.error('服务器出现错误');
          break;
        case 404:
          store.commit('hideLoading');
          // Message.error("404接口调用错误")
          break;
      }
      return Promise.reject(error.response.data);
    }
    if (error && error.stack.indexOf('timeout') > -1) {
      store.commit('hideLoading');
      Message.error('现在网络不稳定,请稍后在试!');
    } else {
      console.log(local.get('Token'), '*45454545');
    }
  }
);

export default axios;
